import { Typography } from '@mui/material';

import { INode } from '../../Context/FormBuilderContext';

interface TitleWidgetProps {
  node: INode;
}

export function TitleWidget({ node }: TitleWidgetProps) {
  const styles = node?.data?.styles;

  return (
    <>
      {node?.data?.title && (
        <Typography
          style={{
            fontFamily: styles?.title?.fontFamily || 'Roboto, sans-serif',
            fontWeight: styles?.title?.isBold ? '700' : '400',
            fontStyle: styles?.title?.isItalic ? 'italic' : 'normal',
            textDecoration: styles?.title?.isUnderlined ? 'underline' : 'none',
            fontSize: `${styles?.title?.fontSize || 16}px`,
            color: styles?.title?.color || '#1F2937',
            width: '100%',
            lineHeight: '150%',
            textAlign: styles?.title?.textAlign || 'left',
            letterSpacing: '0.5px',
          }}
        >
          {node?.data?.title}
        </Typography>
      )}
    </>
  );
}
